import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/loans",
        name: "loans",
        component: () => import("./pages/LoanList.vue"),
        meta: {
            requiresAuth: true,
            title: "loans.title_management",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.loans" },
            ],
        },
    },
    {
        path: "/loans/create",
        name: "loans-create",
        component: () => import("./pages/LoanForm.vue"),
        meta: {
            requiresAuth: true,
            title: "loans.request",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.loans", to: "/loans" },
                { label: "loans.request" },
            ],
        },
    },
    {
        path: "/loans/:id",
        name: "loans-view",
        component: () => import("./pages/LoanForm.vue"),
        meta: {
            requiresAuth: true,
            title: "loans.view",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.loans", to: "/loans" },
                { label: "loans.view" },
            ],
        },
    },
    {
        path: "/loans/calendar",
        name: "loans-calendar",
        component: () => import("./pages/LoansCalendar.vue"),
        meta: {
            requiresAuth: true,
            title: "loans.calendar_title",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.loans", to: "/loans" },
                { label: "loans.calendar_title" },
            ],
        },
    },
];

export default routes;
